module.exports = {
	"aes-128-ecb": {
		"cipher": "AES",
		"key": 128,
		"iv": 0,
		"mode": "ECB",
		"type": "block"
	},
	"aes-192-ecb": {
		"cipher": "AES",
		"key": 192,
		"iv": 0,
		"mode": "ECB",
		"type": "block"
	},
	"aes-256-ecb": {
		"cipher": "AES",
		"key": 256,
		"iv": 0,
		"mode": "ECB",
		"type": "block"
	},
	"aes-128-cbc": {
		"cipher": "AES",
		"key": 128,
		"iv": 16,
		"mode": "CBC",
		"type": "block"
	},
	"aes-192-cbc": {
		"cipher": "AES",
		"key": 192,
		"iv": 16,
		"mode": "CBC",
		"type": "block"
	},
	"aes-256-cbc": {
		"cipher": "AES",
		"key": 256,
		"iv": 16,
		"mode": "CBC",
		"type": "block"
	},
	"aes128": {
		"cipher": "AES",
		"key": 128,
		"iv": 16,
		"mode": "CBC",
		"type": "block"
	},
	"aes192": {
		"cipher": "AES",
		"key": 192,
		"iv": 16,
		"mode": "CBC",
		"type": "block"
	},
	"aes256": {
		"cipher": "AES",
		"key": 256,
		"iv": 16,
		"mode": "CBC",
		"type": "block"
	},
	"aes-128-cfb": {
		"cipher": "AES",
		"key": 128,
		"iv": 16,
		"mode": "CFB",
		"type": "stream"
	},
	"aes-192-cfb": {
		"cipher": "AES",
		"key": 192,
		"iv": 16,
		"mode": "CFB",
		"type": "stream"
	},
	"aes-256-cfb": {
		"cipher": "AES",
		"key": 256,
		"iv": 16,
		"mode": "CFB",
		"type": "stream"
	},
	"aes-128-cfb8": {
		"cipher": "AES",
		"key": 128,
		"iv": 16,
		"mode": "CFB8",
		"type": "stream"
	},
	"aes-192-cfb8": {
		"cipher": "AES",
		"key": 192,
		"iv": 16,
		"mode": "CFB8",
		"type": "stream"
	},
	"aes-256-cfb8": {
		"cipher": "AES",
		"key": 256,
		"iv": 16,
		"mode": "CFB8",
		"type": "stream"
	},
	"aes-128-cfb1": {
		"cipher": "AES",
		"key": 128,
		"iv": 16,
		"mode": "CFB1",
		"type": "stream"
	},
	"aes-192-cfb1": {
		"cipher": "AES",
		"key": 192,
		"iv": 16,
		"mode": "CFB1",
		"type": "stream"
	},
	"aes-256-cfb1": {
		"cipher": "AES",
		"key": 256,
		"iv": 16,
		"mode": "CFB1",
		"type": "stream"
	},
	"aes-128-ofb": {
		"cipher": "AES",
		"key": 128,
		"iv": 16,
		"mode": "OFB",
		"type": "stream"
	},
	"aes-192-ofb": {
		"cipher": "AES",
		"key": 192,
		"iv": 16,
		"mode": "OFB",
		"type": "stream"
	},
	"aes-256-ofb": {
		"cipher": "AES",
		"key": 256,
		"iv": 16,
		"mode": "OFB",
		"type": "stream"
	},
	"aes-128-ctr": {
		"cipher": "AES",
		"key": 128,
		"iv": 16,
		"mode": "CTR",
		"type": "stream"
	},
	"aes-192-ctr": {
		"cipher": "AES",
		"key": 192,
		"iv": 16,
		"mode": "CTR",
		"type": "stream"
	},
	"aes-256-ctr": {
		"cipher": "AES",
		"key": 256,
		"iv": 16,
		"mode": "CTR",
		"type": "stream"
	},
	"aes-128-gcm": {
		"cipher": "AES",
		"key": 128,
		"iv": 12,
		"mode": "GCM",
		"type": "auth"
	},
	"aes-192-gcm": {
		"cipher": "AES",
		"key": 192,
		"iv": 12,
		"mode": "GCM",
		"type": "auth"
	},
	"aes-256-gcm": {
		"cipher": "AES",
		"key": 256,
		"iv": 12,
		"mode": "GCM",
		"type": "auth"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/browserify-aes/modes/list.json
// module id = 281
// module chunks = 0